import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { fieldLabelStyle } from '../lib/theme';
import AuthLayout, {
  authErrorStyle,
  authFieldStyle,
  authFormStyle,
  authSecondaryStyle,
  authSubmitStyle,
} from '../components/AuthLayout';

export default function Signup() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post('/auth/signup', { name, email, password });
      await refresh();
      navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign up failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title="Sign up">
      <form onSubmit={handleSubmit} style={authFormStyle}>
        {error && <p style={authErrorStyle}>{error}</p>}

        <label style={fieldLabelStyle}>
          Name
          <input value={name} onChange={(e) => setName(e.target.value)} style={authFieldStyle} />
        </label>

        <label style={fieldLabelStyle}>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={authFieldStyle} />
        </label>

        <label style={fieldLabelStyle}>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            style={authFieldStyle}
          />
        </label>

        <button type="submit" disabled={submitting} style={authSubmitStyle}>
          {submitting ? 'Creating account…' : 'Create account'}
        </button>

        <a href={`${API_BASE_URL}/auth/gmail`} style={authSecondaryStyle}>
          Sign up with Google
        </a>

        <div style={{ fontSize: '0.85rem', textAlign: 'center' }}>
          Already have an account? <Link to="/login">Log in</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
